
declare let paypal: any;

export default paypal;
